import { ProfileData, Speaker, ParallelEvent } from '../types/profile.types';

// Función helper para obtener el dialCode de un código de país
const getDialCode = (code: string): string => {
  const dialCodes: { [key: string]: string } = {
    'AR': '+54', 'BR': '+55', 'CL': '+56', 'CO': '+57', 'MX': '+52', 'PE': '+51',
    'UY': '+598', 'VE': '+58', 'BO': '+591', 'EC': '+593', 'PY': '+595', 'CR': '+506',
    'PA': '+507', 'GT': '+502', 'HN': '+504', 'SV': '+503', 'NI': '+505', 'CU': '+53',
    'DO': '+1', 'HT': '+509', 'JM': '+1', 'TT': '+1', 'US': '+1', 'CA': '+1',
    'ES': '+34', 'IT': '+39', 'FR': '+33', 'DE': '+49', 'GB': '+44', 'PT': '+351',
    'NL': '+31', 'BE': '+32', 'CH': '+41', 'AT': '+43', 'SE': '+46', 'NO': '+47',
    'DK': '+45', 'FI': '+358', 'PL': '+48', 'CZ': '+420', 'HU': '+36', 'RO': '+40',
    'BG': '+359', 'GR': '+30', 'RU': '+7', 'UA': '+380', 'IE': '+353', 'IS': '+354',
    'CN': '+86', 'JP': '+81', 'KR': '+82', 'IN': '+91', 'TH': '+66', 'SG': '+65',
    'MY': '+60', 'ID': '+62', 'PH': '+63', 'VN': '+84', 'TW': '+886', 'HK': '+852',
    'BD': '+880', 'PK': '+92', 'LK': '+94', 'NP': '+977', 'MM': '+95', 'KH': '+855',
    'LA': '+856', 'MN': '+976', 'AU': '+61', 'NZ': '+64', 'FJ': '+679', 'PG': '+675',
    'NC': '+687', 'ZA': '+27', 'EG': '+20', 'NG': '+234', 'KE': '+254', 'MA': '+212',
    'TN': '+216', 'DZ': '+213', 'GH': '+233', 'ET': '+251', 'UG': '+256', 'TZ': '+255',
    'ZW': '+263', 'BW': '+267', 'NA': '+264', 'ZM': '+260', 'MW': '+265', 'MZ': '+258',
    'MG': '+261', 'MU': '+230', 'SC': '+248', 'SA': '+966', 'AE': '+971', 'QA': '+974',
    'KW': '+965', 'BH': '+973', 'OM': '+968', 'JO': '+962', 'LB': '+961', 'SY': '+963',
    'IQ': '+964', 'IR': '+98', 'IL': '+972', 'TR': '+90'
  };
  return dialCodes[code] || '+54';
};

// Lista de países (igual que PhoneInput)
const countries = [
  { code: 'AR', name: 'Argentina' }, { code: 'BR', name: 'Brasil' },
  { code: 'CL', name: 'Chile' }, { code: 'CO', name: 'Colombia' },
  { code: 'MX', name: 'México' }, { code: 'PE', name: 'Perú' },
  { code: 'UY', name: 'Uruguay' }, { code: 'VE', name: 'Venezuela' },
  { code: 'BO', name: 'Bolivia' }, { code: 'EC', name: 'Ecuador' },
  { code: 'PY', name: 'Paraguay' }, { code: 'CR', name: 'Costa Rica' },
  { code: 'PA', name: 'Panamá' }, { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' }, { code: 'SV', name: 'El Salvador' },
  { code: 'NI', name: 'Nicaragua' }, { code: 'CU', name: 'Cuba' },
  { code: 'DO', name: 'República Dominicana' }, { code: 'HT', name: 'Haití' },
  { code: 'JM', name: 'Jamaica' }, { code: 'TT', name: 'Trinidad y Tobago' },
  { code: 'US', name: 'Estados Unidos' }, { code: 'CA', name: 'Canadá' },
  { code: 'ES', name: 'España' }, { code: 'IT', name: 'Italia' },
  { code: 'FR', name: 'Francia' }, { code: 'DE', name: 'Alemania' },
  { code: 'GB', name: 'Reino Unido' }, { code: 'PT', name: 'Portugal' },
  { code: 'NL', name: 'Países Bajos' }, { code: 'BE', name: 'Bélgica' },
  { code: 'CH', name: 'Suiza' }, { code: 'AT', name: 'Austria' },
  { code: 'SE', name: 'Suecia' }, { code: 'NO', name: 'Noruega' },
  { code: 'DK', name: 'Dinamarca' }, { code: 'FI', name: 'Finlandia' },
  { code: 'PL', name: 'Polonia' }, { code: 'CZ', name: 'República Checa' },
  { code: 'HU', name: 'Hungría' }, { code: 'RO', name: 'Rumania' },
  { code: 'BG', name: 'Bulgaria' }, { code: 'GR', name: 'Grecia' },
  { code: 'RU', name: 'Rusia' }, { code: 'UA', name: 'Ucrania' },
  { code: 'IE', name: 'Irlanda' }, { code: 'IS', name: 'Islandia' },
  { code: 'CN', name: 'China' }, { code: 'JP', name: 'Japón' },
  { code: 'KR', name: 'Corea del Sur' }, { code: 'IN', name: 'India' },
  { code: 'TH', name: 'Tailandia' }, { code: 'SG', name: 'Singapur' },
  { code: 'MY', name: 'Malasia' }, { code: 'ID', name: 'Indonesia' },
  { code: 'PH', name: 'Filipinas' }, { code: 'VN', name: 'Vietnam' },
  { code: 'TW', name: 'Taiwán' }, { code: 'HK', name: 'Hong Kong' },
  { code: 'BD', name: 'Bangladesh' }, { code: 'PK', name: 'Pakistán' },
  { code: 'LK', name: 'Sri Lanka' }, { code: 'NP', name: 'Nepal' },
  { code: 'MM', name: 'Myanmar' }, { code: 'KH', name: 'Camboya' },
  { code: 'LA', name: 'Laos' }, { code: 'MN', name: 'Mongolia' },
  { code: 'AU', name: 'Australia' }, { code: 'NZ', name: 'Nueva Zelanda' },
  { code: 'FJ', name: 'Fiyi' }, { code: 'PG', name: 'Papúa Nueva Guinea' },
  { code: 'NC', name: 'Nueva Caledonia' }, { code: 'ZA', name: 'Sudáfrica' },
  { code: 'EG', name: 'Egipto' }, { code: 'NG', name: 'Nigeria' },
  { code: 'KE', name: 'Kenia' }, { code: 'MA', name: 'Marruecos' },
  { code: 'TN', name: 'Túnez' }, { code: 'DZ', name: 'Argelia' },
  { code: 'GH', name: 'Ghana' }, { code: 'ET', name: 'Etiopía' },
  { code: 'UG', name: 'Uganda' }, { code: 'TZ', name: 'Tanzania' },
  { code: 'ZW', name: 'Zimbabue' }, { code: 'BW', name: 'Botsuana' },
  { code: 'NA', name: 'Namibia' }, { code: 'ZM', name: 'Zambia' },
  { code: 'MW', name: 'Malaui' }, { code: 'MZ', name: 'Mozambique' },
  { code: 'MG', name: 'Madagascar' }, { code: 'MU', name: 'Mauricio' },
  { code: 'SC', name: 'Seychelles' }, { code: 'SA', name: 'Arabia Saudí' },
  { code: 'AE', name: 'Emiratos Árabes Unidos' }, { code: 'QA', name: 'Catar' },
  { code: 'KW', name: 'Kuwait' }, { code: 'BH', name: 'Baréin' },
  { code: 'OM', name: 'Omán' }, { code: 'JO', name: 'Jordania' },
  { code: 'LB', name: 'Líbano' }, { code: 'SY', name: 'Siria' },
  { code: 'IQ', name: 'Irak' }, { code: 'IR', name: 'Irán' },
  { code: 'IL', name: 'Israel' }, { code: 'TR', name: 'Turquía' }
];

const validatePhoneNumber = (countryCode: string, phoneNumber: string): boolean => {
  if (!phoneNumber || !phoneNumber.trim()) return true; // Vacío es válido si no es requerido
  const country = countries.find(c => c.code === countryCode);
  if (!country) return false;
  const cleanNumber = phoneNumber.replace(/\D/g, '');
  const patterns: { [key: string]: RegExp } = {
    'AR': /^\d{10,11}$/, 'BR': /^\d{10,11}$/, 'CL': /^\d{8,9}$/,
    'CO': /^\d{10}$/, 'MX': /^\d{10}$/, 'PE': /^\d{9}$/,
    'UY': /^\d{8,9}$/, 'VE': /^\d{10,11}$/, 'BO': /^\d{8}$/,
    'EC': /^\d{9}$/, 'PY': /^\d{9}$/, 'CR': /^\d{8}$/,
    'PA': /^\d{8}$/, 'GT': /^\d{8}$/, 'HN': /^\d{8}$/,
    'SV': /^\d{8}$/, 'NI': /^\d{8}$/, 'CU': /^\d{8}$/,
    'DO': /^\d{10}$/, 'HT': /^\d{8}$/, 'JM': /^\d{10}$/,
    'TT': /^\d{10}$/, 'US': /^\d{10}$/, 'CA': /^\d{10}$/,
    'ES': /^\d{9}$/, 'IT': /^\d{10,11}$/, 'FR': /^\d{10}$/,
    'DE': /^\d{10,11}$/, 'GB': /^\d{10,11}$/, 'PT': /^\d{9}$/,
    'NL': /^\d{9}$/, 'BE': /^\d{9}$/, 'CH': /^\d{9}$/,
    'AT': /^\d{10,11}$/, 'SE': /^\d{9}$/, 'NO': /^\d{8}$/,
    'DK': /^\d{8}$/, 'FI': /^\d{9,10}$/, 'PL': /^\d{9}$/,
    'CZ': /^\d{9}$/, 'HU': /^\d{9}$/, 'RO': /^\d{10}$/,
    'BG': /^\d{9}$/, 'GR': /^\d{10}$/, 'RU': /^\d{10,11}$/,
    'UA': /^\d{9}$/, 'IE': /^\d{9}$/, 'IS': /^\d{7}$/,
    'CN': /^\d{11}$/, 'JP': /^\d{10,11}$/, 'KR': /^\d{10,11}$/,
    'IN': /^\d{10}$/, 'TH': /^\d{9}$/, 'SG': /^\d{8}$/,
    'MY': /^\d{9,10}$/, 'ID': /^\d{10,12}$/, 'PH': /^\d{10}$/,
    'VN': /^\d{9,10}$/, 'TW': /^\d{9}$/, 'HK': /^\d{8}$/,
    'BD': /^\d{10}$/, 'PK': /^\d{10}$/, 'LK': /^\d{9}$/,
    'NP': /^\d{10}$/, 'MM': /^\d{9,10}$/, 'KH': /^\d{8,9}$/,
    'LA': /^\d{8,9}$/, 'MN': /^\d{8}$/, 'AU': /^\d{9,10}$/,
    'NZ': /^\d{8,9}$/, 'FJ': /^\d{7,8}$/, 'PG': /^\d{8}$/,
    'NC': /^\d{6}$/, 'ZA': /^\d{9}$/, 'EG': /^\d{10}$/,
    'NG': /^\d{10,11}$/, 'KE': /^\d{9,10}$/, 'MA': /^\d{9}$/,
    'TN': /^\d{8}$/, 'DZ': /^\d{9}$/, 'GH': /^\d{9}$/,
    'ET': /^\d{9}$/, 'UG': /^\d{9}$/, 'TZ': /^\d{9}$/,
    'ZW': /^\d{9}$/, 'BW': /^\d{7,8}$/, 'NA': /^\d{9}$/,
    'ZM': /^\d{9}$/, 'MW': /^\d{9}$/, 'MZ': /^\d{9}$/,
    'MG': /^\d{9}$/, 'MU': /^\d{7,8}$/, 'SC': /^\d{7}$/,
    'SA': /^\d{9}$/, 'AE': /^\d{9}$/, 'QA': /^\d{8}$/,
    'KW': /^\d{8}$/, 'BH': /^\d{8}$/, 'OM': /^\d{8}$/,
    'JO': /^\d{9}$/, 'LB': /^\d{8}$/, 'SY': /^\d{9}$/,
    'IQ': /^\d{10}$/, 'IR': /^\d{10}$/, 'IL': /^\d{9}$/,
    'TR': /^\d{10,11}$/
  };
  const pattern = patterns[countryCode];
  return pattern ? pattern.test(cleanNumber) : /^\d{8,15}$/.test(cleanNumber);
};

const validateEmail = (email: string): boolean => {
  if (!email || !email.trim()) return true; // Vacío es válido si no es requerido
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

const validateUrl = (url: string): boolean => {
  if (!url || !url.trim()) return true; // Campo opcional
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
    return urlRegex.test(url);
  }
  const domainRegex = /^(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
  return domainRegex.test(url);
};

export interface ValidationError {
  field: string;
  label: string;
  tab: string;
  subTab?: string;
}

// Validar Biografía: solo verifica que sea una URL válida si tiene contenido
// La validación de si está completo (obligatorio si LinkedIn está vacío) la maneja otro modal
const validateBiography = (biography: string): boolean => {
  if (!biography || !biography.trim()) {
    return true; // Vacío es válido (la completitud la valida otro modal)
  }
  // Si tiene contenido, debe ser una URL válida
  return validateUrl(biography);
};

export const validateProfile = (data: ProfileData): ValidationError[] => {
  const errors: ValidationError[] = [];

  // =====================================================
  // PERFIL PERSONAL
  // =====================================================
  if (data.contactInfo) {
    // Teléfono
    // CRÍTICO: Verificar tanto numeroTelefono como phone para asegurar que se valide correctamente
    const numeroTelefono = data.contactInfo.numeroTelefono || '';
    const phone = data.contactInfo.phone || '';
    
    // Si hay numeroTelefono, validarlo
    if (numeroTelefono && numeroTelefono.trim()) {
      const codigoPais = data.contactInfo.codigoPais || 'AR';
      if (!validatePhoneNumber(codigoPais, numeroTelefono)) {
        errors.push({
          field: 'numeroTelefono',
          label: 'Teléfono',
          tab: 'Información Personal'
        });
      }
    }
    // Si no hay numeroTelefono pero hay phone, intentar parsear phone para obtener numeroTelefono
    else if (phone && phone.trim() && !numeroTelefono) {
      // Intentar extraer el número del phone (que incluye el dialCode)
      const phoneWithoutDialCode = phone.replace(/^\+\d{1,4}\s*/, '').trim();
      if (phoneWithoutDialCode) {
        // Intentar determinar el código de país desde el phone
        const dialCodeMatch = phone.match(/^\+(\d{1,4})/);
        let codigoPais = 'AR'; // Por defecto
        if (dialCodeMatch) {
          const dialCode = `+${dialCodeMatch[1]}`;
          // Buscar el código de país que coincida con el dialCode
          for (const country of countries) {
            if (getDialCode(country.code) === dialCode) {
              codigoPais = country.code;
              break;
            }
          }
        }
        if (!validatePhoneNumber(codigoPais, phoneWithoutDialCode)) {
          errors.push({
            field: 'numeroTelefono',
            label: 'Teléfono',
            tab: 'Información Personal'
          });
        }
      }
    }

    // Sitio web (está en basicInfo pero se muestra en Perfil Personal)
    if (data.basicInfo?.website && data.basicInfo.website.trim()) {
      if (!validateUrl(data.basicInfo.website)) {
        errors.push({
          field: 'website',
          label: 'Sitio web',
          tab: 'Información Personal'
        });
      }
    }
  }

  // =====================================================
  // INFO DE LA ORG
  // =====================================================
  if (data.basicInfo?.socialNetworks) {
    const socialNetworks = data.basicInfo.socialNetworks;
    
    if (socialNetworks.facebook && socialNetworks.facebook.trim() && !validateUrl(socialNetworks.facebook)) {
      errors.push({
        field: 'facebook',
        label: 'Facebook',
        tab: 'Información de la Organización'
      });
    }
    
    if (socialNetworks.twitter && socialNetworks.twitter.trim() && !validateUrl(socialNetworks.twitter)) {
      errors.push({
        field: 'twitter',
        label: 'Twitter',
        tab: 'Información de la Organización'
      });
    }
    
    if (socialNetworks.linkedin && socialNetworks.linkedin.trim() && !validateUrl(socialNetworks.linkedin)) {
      errors.push({
        field: 'linkedin',
        label: 'LinkedIn',
        tab: 'Información de la Organización'
      });
    }
    
    if (socialNetworks.instagram && socialNetworks.instagram.trim() && !validateUrl(socialNetworks.instagram)) {
      errors.push({
        field: 'instagram',
        label: 'Instagram',
        tab: 'Información de la Organización'
      });
    }
    
    if (socialNetworks.youtube && socialNetworks.youtube.trim() && !validateUrl(socialNetworks.youtube)) {
      errors.push({
        field: 'youtube',
        label: 'YouTube',
        tab: 'Información de la Organización'
      });
    }
    
    if (socialNetworks.other && socialNetworks.other.trim() && !validateUrl(socialNetworks.other)) {
      errors.push({
        field: 'other',
        label: 'Otra red social',
        tab: 'Información de la Organización'
      });
    }
  }

  // =====================================================
  // ORADORES
  // =====================================================
  if (data.speakers && data.speakers.length > 0) {
    data.speakers.forEach((speaker: Speaker, index: number) => {
      // Biografía: solo valida que sea URL válida si tiene contenido
      if (speaker.biography && speaker.biography.trim() && !validateBiography(speaker.biography)) {
        errors.push({
          field: 'biography',
          label: 'Biografía',
          tab: 'Oradores',
          subTab: `Orador ${index + 1}`
        });
      }
      
      // LinkedIn
      if (speaker.linkedin && speaker.linkedin.trim() && !validateUrl(speaker.linkedin)) {
        errors.push({
          field: 'linkedin',
          label: 'LinkedIn',
          tab: 'Oradores',
          subTab: `Orador ${index + 1}`
        });
      }
      
      // Instagram
      if (speaker.instagram && speaker.instagram.trim() && !validateUrl(speaker.instagram)) {
        errors.push({
          field: 'instagram',
          label: 'Instagram',
          tab: 'Oradores',
          subTab: `Orador ${index + 1}`
        });
      }
      
      // Twitter/X
      if (speaker.twitter && speaker.twitter.trim() && !validateUrl(speaker.twitter)) {
        errors.push({
          field: 'twitter',
          label: 'Twitter/X',
          tab: 'Oradores',
          subTab: `Orador ${index + 1}`
        });
      }
    });
  }

  // =====================================================
  // ORADORES DENTRO DE EVENTOS PARALELOS
  // =====================================================
  if (data.parallelEvents && data.parallelEvents.length > 0) {
    data.parallelEvents.forEach((event: ParallelEvent, eventIndex: number) => {
      // Validar oradores locales dentro del evento
      if (event.localSpeakers && event.localSpeakers.length > 0) {
        event.localSpeakers.forEach((speaker: Speaker, speakerIndex: number) => {
          // Biografía: solo valida que sea URL válida si tiene contenido
          if (speaker.biography && speaker.biography.trim() && !validateBiography(speaker.biography)) {
            errors.push({
              field: 'biography',
              label: 'Biografía',
              tab: 'Eventos Paralelos',
              subTab: `Evento ${eventIndex + 1} - Orador ${speakerIndex + 1}`
            });
          }
          
          // LinkedIn
          if (speaker.linkedin && speaker.linkedin.trim() && !validateUrl(speaker.linkedin)) {
            errors.push({
              field: 'linkedin',
              label: 'LinkedIn',
              tab: 'Eventos Paralelos',
              subTab: `Evento ${eventIndex + 1} - Orador ${speakerIndex + 1}`
            });
          }
          
          // Instagram
          if (speaker.instagram && speaker.instagram.trim() && !validateUrl(speaker.instagram)) {
            errors.push({
              field: 'instagram',
              label: 'Instagram',
              tab: 'Eventos Paralelos',
              subTab: `Evento ${eventIndex + 1} - Orador ${speakerIndex + 1}`
            });
          }
          
          // Twitter/X
          if (speaker.twitter && speaker.twitter.trim() && !validateUrl(speaker.twitter)) {
            errors.push({
              field: 'twitter',
              label: 'Twitter/X',
              tab: 'Eventos Paralelos',
              subTab: `Evento ${eventIndex + 1} - Orador ${speakerIndex + 1}`
            });
          }
        });
      }
    });
  }

  // =====================================================
  // INICIATIVAS
  // =====================================================
  if (data.initiatives && data.initiatives.length > 0) {
    data.initiatives.forEach((initiative: any, index: number) => {
      // Correo del contacto
      if (initiative.contactEmail && initiative.contactEmail.trim()) {
        if (!validateEmail(initiative.contactEmail)) {
          errors.push({
            field: 'contactEmail',
            label: 'Correo electrónico',
            tab: 'Iniciativas',
            subTab: `Iniciativa ${index + 1}`
          });
        }
      }
      
      // Teléfono del contacto
      if (initiative.contactNumeroTelefono && initiative.contactNumeroTelefono.trim()) {
        const codigoPais = initiative.contactCodigoPais || 'AR';
        if (!validatePhoneNumber(codigoPais, initiative.contactNumeroTelefono)) {
          errors.push({
            field: 'contactNumeroTelefono',
            label: 'Teléfono',
            tab: 'Iniciativas',
            subTab: `Iniciativa ${index + 1}`
          });
        }
      }
    });
  }

  // =====================================================
  // PARTICIPANTES DE LAS RONDAS
  // =====================================================
  if (data.businessRoundsParticipants && data.businessRoundsParticipants.length > 0) {
    data.businessRoundsParticipants.forEach((participant: any, index: number) => {
      // Correo electrónico
      if (participant.email && participant.email.trim()) {
        if (!validateEmail(participant.email)) {
          errors.push({
            field: 'email',
            label: 'Correo electrónico',
            tab: 'Participantes en las Rondas de Negocios',
            subTab: `Participante ${index + 1}`
          });
        }
      }

      // Teléfono
      if (participant.numeroTelefono && participant.numeroTelefono.trim()) {
        const codigoPais = participant.codigoPais || 'AR';
        if (!validatePhoneNumber(codigoPais, participant.numeroTelefono)) {
          errors.push({
            field: 'numeroTelefono',
            label: 'Teléfono',
            tab: 'Participantes en las Rondas de Negocios',
            subTab: `Participante ${index + 1}`
          });
        }
      }
    });
  }

  return errors;
};
